import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "log-history-container" }
const _hoisted_2 = { class: "log-header" }
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = {
  key: 1,
  class: "error-state"
}
const _hoisted_5 = {
  key: 2,
  class: "log-content"
}
const _hoisted_6 = { class: "category-title" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-striped table-bordered" }
const _hoisted_9 = {
  key: 0,
  class: "landmark"
}
const _hoisted_10 = {
  key: 1,
  class: "completed-status"
}
const _hoisted_11 = { class: "sub-cat-details" }

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'loghistory',
  setup(__props) {

const route = useRoute()
const logNo = ref(route.params.logNo as string)
const categories = ref<any>(null)
const loading = ref(true)
const error = ref('')
const baseUrl = process.env.VUE_APP_BASE_URL;

const fetchLogHistory = async () => {
  try {
    const response = await axios.get(`${baseUrl}api/operation/kyt/log/${logNo.value}`)
    categories.value = response.data.categories
  } catch (err) {
    error.value = 'Failed to fetch log history'
    console.error('Error fetching log history:', err)
  } finally {
    loading.value = false
  }
}

const formatCategoryName = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1)
}

const formatDate = (date: string) => {
  if (!date) return 'N/A'
  return new Date(date).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

const getStatusClass = (status: string) => {
  return {
    'badge rounded-pill': true,
    'bg-success': status === 'approved',
    'bg-warning text-dark': status === 'pending',
    'bg-danger': status === 'rejected'
  }
}

onMounted(() => {
  fetchLogHistory()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, "Log History - " + _toDisplayString(logNo.value), 1)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "spinner" }, null, -1),
          _createElementVNode("p", null, "Loading log history...", -1)
        ]))]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(error.value), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (categoryData, categoryName) => {
              return (_openBlock(), _createElementBlock("div", {
                key: categoryName,
                class: "category-section"
              }, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(formatCategoryName(categoryName)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Site Name"),
                        _createElementVNode("th", null, "Address"),
                        _createElementVNode("th", null, "NFD Date"),
                        _createElementVNode("th", null, "Status"),
                        _createElementVNode("th", null, "Problem"),
                        _createElementVNode("th", null, "Solution"),
                        _createElementVNode("th", null, "Sub Categories")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryData.kyts, (kyt) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: kyt._id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("strong", null, _toDisplayString(kyt.siteName), 1),
                            (kyt.landmark)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Landmark: " + _toDisplayString(kyt.landmark), 1))
                              : _createCommentVNode("", true),
                            (kyt.isCompleted)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("i", { class: "fas fa-check-circle text-success" }, null, -1),
                                  _createTextVNode(" Completed ", -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(kyt.siteAddress), 1),
                          _createElementVNode("td", null, _toDisplayString(formatDate(kyt.NFD)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(getStatusClass(kyt.status))
                            }, _toDisplayString(kyt.status), 3)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kyt.kytData[categoryName], (formatData, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(formatData.problem), 1))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kyt.kytData[categoryName], (formatData, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(formatData.solution), 1))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kyt.kytData[categoryName], (formatData, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "format-section"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatData.subCategories, (subCat, subIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: subIndex,
                                    class: "sub-category"
                                  }, [
                                    _createElementVNode("strong", null, _toDisplayString(subCat.subCategory), 1),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("p", null, [
                                        _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Problem:", -1)),
                                        _createTextVNode(" " + _toDisplayString(subCat.problem), 1)
                                      ]),
                                      _createElementVNode("p", null, [
                                        _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Solution:", -1)),
                                        _createTextVNode(" " + _toDisplayString(subCat.solution), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
  ]))
}
}

})